import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { PersonIcon } from './utils/IconFactory';
export default function Avatar({ size = 24, className = '', image, active = false, color, bgColor = 'transparent' }) {
    const styles = {};
    if (image) {
        styles.backgroundImage = `url(${image})`;
        return _jsx(ContainerImage, { size: size, className: `${className} ui-avatar`, style: styles, children: active && _jsx(Active, {}) });
    }
    return _jsx(ContainerIcon, { size: size, className: `${className} ui-avatar`, style: styles, color: color, bgColor: bgColor, children: _jsx(PersonIcon, {}) });
}
const ContainerImage = styled('span') `
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;

  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

  ${props => props.size && css `
    width: ${props.size / 16}rem;
    height: ${props.size / 16}rem;
  `}
`;
const ContainerIcon = styled('span') `
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;

  ${props => props.color && css `
    color: ${props.color};
  `}

  ${props => props.bgColor && css `
    background: ${props.bgColor};
  `}

  ${props => props.size && css `
    width: ${props.size / 16}rem;
    height: ${props.size / 16}rem;
  `}

  svg {
    width: 80%;
    height: 80%;
  }
`;
const Active = styled.span `
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 0.375rem;
  height: 0.375rem;
  background: var(--colors-orange);
  border: 0.2rem solid var(--bg-400);
  border-radius: 50%;
`;
